import { Link } from '@podiumhq/design-system';

import env from 'env';

import { FormElementFieldError } from './FormElementFieldError';

export const FormElementWrapperWithAccountExists = ({
  children,
  fieldExists,
  fieldName,
  ...props
}) => (
  <>
    {children}

    <FormElementFieldError
      displayError={fieldExists}
      fontSize="md"
      id={`${fieldName}-exists-message`}
      mb="24px"
      mt={fieldExists ? '-16px' : '0'}
      {...props}
    >
      Looks like you already have an account{' '}
      <Link
        fontWeight="semibold"
        href={env.KAZAAM_URL}
        id="sign-in-link"
        target="blank"
        textDecoration="underline"
      >
        Sign in
      </Link>
    </FormElementFieldError>
  </>
);
